export default abstract class Cache<T> {
  protected hasPrev = false;
  protected cache: Map<number, Promise<T>> = new Map<number, Promise<T>>();

  abstract getPrevious(cacheId: number): Promise<T>;
}
